import { Duration } from 'date-fns';

// formatMinSecDuration formats a Duration object into a string in the format "MM:SS".  If the duration is null or
// undefined, it returns the `undefinedResponse` which defaults to "00:00".
export const formatMinSecDuration = (duration: Duration, undefinedResponse = '00:00') => {
  if (!duration) {
    return undefinedResponse;
  }
  const minutes = String(duration.minutes).padStart(2, '0');
  const seconds = String(duration.seconds).padStart(2, '0');
  return `${minutes}:${seconds}`;
};
